// LiveStreamCountDown.js
import { connect } from 'react-redux';

import getUserData from '../selector/getUserData.js';
import getMeData from '../selector/getMeData.js';
import getMeBalance from '../selector/getMeBalance.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getLiveStreamPrice from '../selector/getLiveStreamPrice.js';
import { getIsDrmRequirementMatched } from '../selector/getDrmKeySystemAndRobustness.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getShouldShowLivestreamCta from '../selector/getShouldShowLivestreamCta.js';
import getModalData from '../selector/getModalData.js';

import addvalue from '../action/addvalue.js';
import addModal from '../action/addModal.js';
import login from '../action/login.js';
import unlockPrivateStream from '../action/unlockPrivateStream.js';
import pushToastr from '../action/pushToastr.js';
import addPopupNotification from '../action/addPopupNotification.js';
import closePopupNotifications from '../action/closePopupNotifications.js';

import { PRESET_SD } from '../resource/liveStreamConstants.js';
import {
  drmRulesetTestStatus as drmRulesetTestStatusConstant,
  DrmFeatureName,
} from '../resource/drmConstants.js';
import {
  STATUS_OPENED,
  STATUS_OPENING,
  MODAL_ID_PREFIX,
  LIVESTREAM_PROMOTION_POPUP_ID,
} from '../resource/popupNotificationConstants.js';

import LiveStreamCountDown from '../component/LiveStreamCountDown.jsx';

import {
  NEED_AUTH_HANDLER,
  LIVESTREAM_PAY_DURATION_SECONDS,
  FEATURE_FREE_LIVESTREAM_TO_PRIVATE_LIVESTREAM_PACKAGE_POPUP,
  FREE_LIVESTREAM_TO_PRIVATE_LIVESTREAM_PACKAGE_POPUP_THRESHOLD_SECONDS,
  POPUP_NOTIFICATION_LIVESTREAM_PROMOTION_TEMPLATE_ID,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const privateLiveStreamStartTimestamp = getLiveStreamData(
    state,
    [streamId, 'presets', PRESET_SD],
    'nbf'
  );
  const isPrivateStreamUnlocked = getOperationData(
    state,
    ['liveStream', 'paid', streamId],
    'isPrivateStreamUnlocked'
  );
  const isFetchingDrmLicense = getNetworkingData(
    state,
    ['drm', 'live', streamId],
    'isFetching'
  );
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const isFetchingStreamToken = getNetworkingData(
    state,
    ['fetch', 'streamToken', sessionId],
    'isFetching'
  );
  const meId = getMeData(state, 'id');
  const productId = getLiveStreamData(state, [streamId, 'shop'], 'productId');
  const isPrivateStreamSubscribed = getOperationData(
    state,
    ['pusher', 'channels'],
    `private-enc-stream@${streamId}`
  )?.subscribed;
  const hasStreamToken = !!getOperationData(
    state,
    ['liveStream', 'paid', streamId],
    'streamToken'
  );
  const isPrivateLiveStreamStarted = !!getLiveStreamData(
    state,
    [streamId],
    'isPrivateLiveStreamStarted'
  );
  const price = getLiveStreamPrice(state, streamId, PRESET_SD);
  const priceDurationMinutes =
    getRemoteConfigData(state, LIVESTREAM_PAY_DURATION_SECONDS) / 60;
  const isAuthed = !!meId;
  const shouldShowPrice = isPrivateStreamSubscribed && price != null;
  const drmTestStatus = getOperationData(state, ['drm'], 'testStatus');
  const shouldShowLoadingOnUnlockButton =
    drmRulesetTestStatusConstant.TESTING === drmTestStatus ||
    !shouldShowPrice ||
    isFetchingDrmLicense ||
    isFetchingStreamToken ||
    (isPrivateLiveStreamStarted && isPrivateStreamUnlocked && !hasStreamToken);

  const isPromotionPopupOpened = [STATUS_OPENED, STATUS_OPENING].includes(
    getModalData(
      state,
      `${MODAL_ID_PREFIX}${LIVESTREAM_PROMOTION_POPUP_ID}`,
      'status'
    )
  );

  return {
    privateLiveStreamStartTimestamp,
    productId,
    isAuthed,
    hasBalance: getMeData(state, 'hasBalance'),
    isPrivateStreamUnlocked,
    isScheduledPrivateLiveStream: !!privateLiveStreamStartTimestamp,
    balance: getMeBalance(state),
    username: getUserData(state, streamId, 'username'),
    price,
    priceDurationMinutes,
    isFetchingDrmLicense,
    shouldShowLoadingOnUnlockButton,
    isPrivateLiveStreamStarted,
    hasStreamToken,
    shouldShowPrice,
    isDrmRequirementMatched: getIsDrmRequirementMatched(
      state,
      DrmFeatureName.LIVESTREAM
    ),
    shouldShowLivestreamCta: getShouldShowLivestreamCta(state, streamId),
    needAuthHandler: getRemoteConfigData(state, NEED_AUTH_HANDLER),
    fundingId: getLiveStreamData(state, [streamId, 'privateShow'], 'fundingId'),
    streamStatus: getLiveStreamData(state, [streamId], 'status'),
    livestreamStartTime: getOperationData(state, ['liveStream'], 'startTime'),
    isFreeToPrivateLiveStreamPackagePopupEnabled:
      getRemoteConfigData(
        state,
        FEATURE_FREE_LIVESTREAM_TO_PRIVATE_LIVESTREAM_PACKAGE_POPUP
      ) === 1,
    freeToPrivateLiveStreamPackagePopupThresholdSeconds: getRemoteConfigData(
      state,
      FREE_LIVESTREAM_TO_PRIVATE_LIVESTREAM_PACKAGE_POPUP_THRESHOLD_SECONDS
    ),
    popupNotificationLiveStreamPromotionTemplateId: getRemoteConfigData(
      state,
      POPUP_NOTIFICATION_LIVESTREAM_PROMOTION_TEMPLATE_ID
    ),
    isPromotionPopupOpened,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    openModal: ({ id }) => dispatch(addModal({ id })),
    addvalue: ({ via = 'insufficient' }) => dispatch(addvalue({ via })),
    unlockPrivateStream: data => dispatch(unlockPrivateStream(data)),
    pushToastr: data => dispatch(pushToastr(data)),
    addPopupNotification: data => dispatch(addPopupNotification(data)),
    closePopupNotifications: data => dispatch(closePopupNotifications(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamCountDown);
